<div *ngIf="!loading && termsLoaded; else loadingWidget" class="page-list">
  <div *ngFor="let page of pages" class="row mb-5" [class.deleting]="page.PageType === undefined">
    <div class="col-4 col-md-4 col-lg-3 col-xl-3 col-xxl-2">
      <div *ngIf="page.BannerImageUrl" class="image-container">
        <img class="image" [appImgSrcProxy]="page.BannerImageUrl" *ngIf="page.IsSharePointPage;else lightNewsImage" alt="Banner image" />
        <ng-template #lightNewsImage>
          <img class="image" src="{{page.BannerImageUrl}}" alt="Banner image" />
        </ng-template>
      </div>
      <div *ngIf="!page.BannerImageUrl" class="image-container d-flex align-items-center justify-content-center placeholder-image">
        <h1>
          <i class="ms-Icon mb-0" [ngClass]="{'ms-Icon--PreviewLink':pageType === 0, 'ms-Icon--News':pageType === 1}" aria-hidden="true"></i>
        </h1>
      </div>
      <i *ngIf="page.IsSharePointPage && showSharePointExternalIcon" class="ms-Icon ms-BrandIcon--icon48 ms-BrandIcon--sharepoint sharepoint-icon"></i>
      <a class="stretched-link" [routerLink]="[page.SlugTitle + '-' + page.Id]" *ngIf="!page.IsSharePointPage"></a>
      <a class="stretched-link" href="{{page.Path}}" *ngIf="page.IsSharePointPage"></a>
    </div>
    <div class="col-8 col-md-8 col-lg-9 col-xl-9 col-xxl-10 newscenter-news-item-body">
      <span *ngIf="editorOptionsEnabled && !page.IsSharePointPage" class="float-right pl-4 pr-1 clickable d-block" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{data: {page:page}}">
        <i class="ms-Icon ms-Icon--More" aria-hidden="true"></i>
      </span>
      <h2 class="h55 mb-2">
        <span class="badge accent-2-bg-color text-uppercase rounded-1 mr-1 py-1 px-2" *ngIf="page.IsFeaturedPage" i18n="newscenter featured news tag@@newscenter-featured-news-tag">
          Featured
        </span>
        <ng-container *ngIf='page.IsSharePointPage; else routerAnchor'>
          <a target="_blank" rel="noopener noreferrer" href="{{page.Path}}">
            {{page.Title}}
          </a>
        </ng-container>
        <ng-template #routerAnchor>
          <a [routerLink]="[page.SlugTitle + '-' + page.Id]">
            {{page.Title}}
          </a>
        </ng-template>
      </h2>
      <span class="badge accent-1-bg-color text-uppercase rounded-1 mr-1 py-1 px-2" *ngIf="!page.PublishingDate" i18n="newscenter draft tag@@newscenter-draft-tag">
        Draft
      </span>
      <span class="badge accent-1-bg-color text-uppercase rounded-1 mr-1 py-1 px-2" *ngIf="isScheduledDraft(page.PublishingDate)" i18n="newscenter draft tag@@newscenter-scheduled-tag">
        Scheduled
      </span>
      <div *ngIf="page.PublishingDate as publishingDate" class="text-muted d-inline">
        {{publishingDate|date}}
      </div>
      <div *ngIf="page.SenderTags" class= "accent-1-color ml-4 d-inline">
        {{getSenderTagString(page)}}
      </div>
      <div class="lead-paragraph mb-2">
        <p>{{HTMLToPlainText(page.Content)}}</p>
      </div>
      <div class="news-channels">
        <mat-chip-list>
          <mat-chip *ngIf="getLanguageNameForPage(page)" [selectable]="false" [disableRipple]="true" class="mr-1">
            {{getLanguageNameForPage(page)}}
          </mat-chip>
          <mat-chip *ngFor="let channelName of getChannelNamesForPage(page)" [selectable]="false" [disableRipple]="true" class="mr-1">
            {{channelName}}
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </div>
  <div *ngIf="pages.length === 0">
    <p class="text-muted" i18n="@@page-list-no-pages-found">No pages found</p>
  </div>
</div>

<mat-menu #menu="matMenu" [xPosition]="'before'" [overlapTrigger]="'false'">
  <ng-template matMenuContent let-data="data">
    <button mat-menu-item [routerLink]="[data.page.SlugTitle + '-' + data.page.Id,'edit']" i18n="@@page-list-edit-item">Edit</button>
    <button mat-menu-item (click)="deletePage(data.page)" i18n="@@page-list-delete-item">Delete</button>
  </ng-template>
</mat-menu>
<ng-template #loadingWidget>
  <div>
    <app-widget-placeholder></app-widget-placeholder>
  </div>
</ng-template>
